import React, { ReactNode } from "react"
import { Control } from "react-hook-form"
import { Box } from "@chakra-ui/react"
import BasicInputs from "./BasicInputs/BasicInputs"
import FormDetailHeader from "./FormDetailHeader"

type Props = {
  control: Control<object, any>
  eventId: string
  name: string
  sendConfirmationEmails: boolean
  quantityHelperText?: ReactNode
}

const Registration = ({
  control, eventId, name, sendConfirmationEmails, quantityHelperText,
}: Props) => (
  <Box pb={4}>
    <FormDetailHeader
      name={name}
      description="Allows anyone to register for your event."
    />
    <BasicInputs
      control={control}
      eventId={eventId}
      showVisibilityInput
      showQuantityInput
      quantityHelperText={quantityHelperText}
      showLimitPerSubmission
      showGuestCreation
      sendConfirmationEmails={sendConfirmationEmails}
    />
  </Box>
)

export default Registration
